<template>
  <div class="create-account Orders">
    <section id="servicios" class="secciones seccion-blanca"> 
    <div class="container">
       <h1>Mis compras y pedidos</h1>
     <template v-if="list_cdp.length==0">
       <h3>Usted aun no ha realizado compras o pedidos.</h3>
       <div class="error-actions">
                <router-link to="/productos">Seguir comprando</router-link>
              </div>
     </template>     

      <div class="row">
      <div class="col-sm-12">
            <ul class="list-group">
               <li class="list-group-item list-group-item-action flex-column align-items-start" v-for="cdp in list_cdp" v-bind:key="cdp.cod_cdp">
                  <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-2 h5">{{cdp.date_reg | formatDate}}
                    </h5>
                    <p>Importe total:  <span style="color:red;">{{cdp.total | currency}}</span></p>
                  </div>
                  <div class="row">
                   <div class="col-sm-6 col-marco">
                     <template v-if="cdp.tipo_cdp!=3">
                       
                       <div class="col-sm-12"><p style="text-align: left;"><strong>Número de pedido: </strong>{{ cdp.cod_erp }}</p></div>
                       <div class="col-sm-12"><p style="text-align: left;"><strong>Tipo de comprobante: </strong>{{ (cdp.ruc == "" || cdp.raz_soc == "") ? "Boleta" : "Factura" }}</p></div>
                       <template v-if='cdp.ruc != "" && cdp.raz_soc != ""'>
                        <div class="col-sm-12"><p style="text-align: left;"><strong>RUC:</strong> {{cdp.ruc}}</p></div>
                        <div class="col-sm-12"><p style="text-align: left;"><strong>Razón social:</strong> {{cdp.raz_soc}}</p></div>
                       </template>
                       <div class="col-sm-12"><p style="text-align: left;"><strong>Importe total a pagar: </strong>  <span style="color:red;">{{cdp.total | currency}}</span></p></div>
                       
                     </template>
                    <template v-else>

                      <div class="col-sm-12"><p style="text-align: left;"><strong>Tipo:</strong> Pedido</p></div>
                      <div class="col-sm-12"><p style="text-align: left;"><strong>Importe total a pagar: </strong>  <span style="color:red;">{{cdp.total | currency}}</span></p></div>

                     </template>
                   </div>
                   <div class="col-sm-6 col-marco">
                     <div class="col-sm-12"><p style="text-align: left;"><strong>Fecha de registro:</strong> {{cdp.date_reg | formatDate}}</p></div>
                     <div class="col-sm-12"><p style="text-align: left;"><strong>Estado actual:</strong> {{cdp.state_tracking.desc_state}}</p></div>
                     <div class="col-sm-12" style="text-align: left;"><router-link tag="a" :key="cdp.cod_erp" :to="{ name: 'seguimiento', params: { id: cdp.cod_erp }}" class="btn btn-al-azul-solid btn-card">Ver Seguimiento</router-link></div>
                     
                     
                   </div>
                   <div class="col-sm-12">
                     <div class="table-responsive">
                      <table class="table table-striped table-sm">
                        <thead>
                          <tr>
                            <th scope="col">Descripción</th>
                            <th scope="col">Precio unitario</th>
                            <th scope="col">Cantidad</th>
                            <th scope="col">Sub-total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="product in cdp.ventas_detalle" v-bind:key="product.code_product">
                            <td>{{product.name_product_es}}</td>
                            <td>{{product.sale_price | currency}}</td>
                            <td>{{product.quantity}}</td>
                            <td>{{product.subtotal | currency}}</td>
                          </tr>
                        </tbody>
                      </table>
                      </div>
                   </div>
                  </div>
                </li>
            </ul>
           

        </div>

      </div>
    <template v-if="list_cdp.length>=1">
      <div class="col-xs-12">
             
              <ul role="menubar" aria-disabled="false" aria-label="Pagination" class="pagination b-pagination pagination-sm center-page">
                <template v-if="current_page == 1">
                  <li role="none presentation" class="page-item disabled"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">«</span></a></li>
                </template>
                <template v-else>
                  <li role="none presentation" class="page-item" @click="get_page_data(1)"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">«</span></a></li>
                </template>
                <template v-if="current_page > 1">
                  <li role="none presentation" class="page-item" aria-hidden="true" @click="get_page_data(current_page - 1)"><span class="page-link page-selector">‹</span></li>
                </template>
                <template v-else>
                  <li role="none presentation" class="page-item disabled" aria-hidden="true"><span class="page-link page-selector" >‹</span></li>
                </template>
                <li v-for="page in pages" :key="page" role="none presentation" :class="['page-item', (page === current_page) ? 'active' : '']" @click="get_page_data(page)"><a role="menuitemradio" tabindex="-1" aria-label="Goto page 2" aria-checked="false" aria-posinset="2" aria-setsize="4" target="_self" class="page-link page-selector">{{page}}</a></li>
                <template v-if="current_page == final_page">
                  <li role="none presentation" class="page-item disabled"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">›</span></a></li>
                </template>
                <template v-else>
                  <li role="none presentation" class="page-item" @click="get_page_data(current_page + 1)"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">›</span></a></li>
                </template>
                <template v-if="current_page == final_page">
                  <li role="none presentation" class="page-item disabled"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link"><span class="page-selector" aria-hidden="true">»</span></a></li>
                </template>
                <template v-else>
                  <li role="none presentation" class="page-item" @click="get_page_data(final_page)"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link"><span class="page-selector" aria-hidden="true">»</span></a></li>
                </template>
              </ul>
              
           </div>
      </template>   

    <div class="col" style="padding-top:10px;">
           <div :class="[(mensaje === '') ? 'd-none' : 'alert alert-success']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong>{{ mensaje }}</strong></div>
           <div :class="[(mensaje_error === '') ? 'd-none' : 'alert alert-danger']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong>{{ mensaje_error }}</strong></div>
    </div>

    </div>
   </section>
   <TwoModules></TwoModules>
   <News></News>
  </div>
</template>

<script>
import TwoModules from "@/components/products/TwoModules.vue";
import News from "@/components/products/Guia.vue";
import Vue from 'vue'
import toastr from 'toastr'
import axios from 'axios'
import { successToaster, errorToaster } from "@/components/shared/service/ErrorHandler.js";
import {config_settings} from '@/config.js'

  //HTTP ERROR STATUS
  const NOT_FOUND = 404;
  const BAD_REQUEST = 400;
  const UNAUTHORIZED = 401;
  const CONFLICT = 409;
  const INTERNAL_SERVER_ERROR = 500;

 axios.interceptors.response.use(function (response) { return response; }, 
  function (error) {
    
    if(error.message === 'Network Error'){
      toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
    }
    else if(error.response.status === UNAUTHORIZED){
      if(error.response.data.message === "Access is denied"){
         toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
});

export default {
  name: "CreateAccount",
  created() {
    this.scroll_inicio();
    this.get_cdp_data();
  },
  data() {
    return {
      crit: 5,
      pages: [],
      final_page: 1,
      current_page: 1,
      imgPreUrl : config_settings.PHOTO_SERVER_URL+'/',
      url_image_preview: config_settings.PHOTO_SERVER_URL+'/clients/empty-img.jpg',
      image_portada: config_settings.PHOTO_SERVER_URL+'/clients/empty-img',
      mensaje: "",
      mensaje_error: "",
      list_cdp: [],
      token: localStorage.getItem('access_token'),
      refresh_token: localStorage.getItem('refresh_token')
    }
  },
  components: { TwoModules,
    News},
  methods: {

    ocultar_msjpwd() {
      this.mensaje_contraseña = ""
      this.mensaje_error_contraseña = ""
    },

    onFileChange(e) {
      const file = e.target.files[0];
      this.image_data = file;
      this.url_image_preview = URL.createObjectURL(file);
    },

    refreshToken(){
          var refresh_token = localStorage.getItem('refresh_token');
          var refresh_credentials = new FormData();
          refresh_credentials.append('grant_type', 'refresh_token');
          refresh_credentials.append('refresh_token',  refresh_token);
          refresh_credentials.append('id_store',  config_settings.STORE);

          const refreshingCall = axios({
            method: 'post',
            url: config_settings.AUTH_SERVER_URL+'/oauth/token',
            data: refresh_credentials,
            withCredentials: true,
            auth: {
                username: 'USER_CLIENT_APP',
                password: 'password'
            }})
            .then(response => {
              localStorage.setItem('access_token', response.data.access_token);
              localStorage.setItem('refresh_token', response.data.refresh_token);
              return Promise.resolve(true);
            });
            return refreshingCall;
    },

    scroll_inicio(){
      window.scrollTo(0,0);
    },

     get_cdp_data() {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL+'/GET/cdp',
        headers: {
          Authorization: "Bearer " + localStorage.getItem('access_token')
        }
      })
      .then(response => {
        this.list_cdp = response.data.cdp;
        this.pages = response.data.visible_pages
        this.final_page = response.data.final_page
        this.current_page = 1
        this.mensaje_error = ""
        this.mensaje = ""
      })
      .catch(error => {
        if(error.response.status === UNAUTHORIZED){
           this.refreshToken().then(_ => {
           this.get_cdp_data();
           })
           .catch(_ => {
           toastr.error("Debe iniciar sesión antes de continuar",
                       "Error",
                       {"iconClass": 'customer-danger'});
           this.mensaje_error = "Debe iniciar sesión antes de continuar";
           this.mensaje = "";
                       this.$router.push({path: '../../../login/'})
           });
         }
         else {
          // toastr.error(error.response.data.details,
            //           error.response.data.message,
              //         {"iconClass": 'customer-danger'});
         }  
      })
    },

    get_page_data(page) {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL+'/GET/cdp?nPag='+page,
        headers: {
          Authorization: "Bearer " + localStorage.getItem('access_token')
        }
      })
      .then(response => {
        this.list_cdp = response.data.cdp;
        this.pages = response.data.visible_pages
        this.final_page = response.data.final_page
        this.current_page = page
        this.mensaje_error = ""
        this.mensaje = ""
        this.scroll_inicio();
      })
      .catch(error => {
        if(error.response.status === UNAUTHORIZED){
           this.refreshToken().then(_ => {
           this.get_page_data(page);
           })
           .catch(_ => {
          
           toastr.error("Debe iniciar sesión antes de continuar",
                       "Error",
                       {"iconClass": 'customer-danger'});
           this.mensaje_error = "Debe iniciar sesión antes de continuar";
           this.mensaje = "";
                       this.$router.push({path: '../../../login/'})
           });
         }
         else if (error.response.status === NOT_FOUND){
                this.get_page_data(page-1);
         }  
         else {
           toastr.error(error.response.data.details,
                       error.response.data.message,
                       {"iconClass": 'customer-danger'});
         }  
      })
    },
    
    ocultar(){
       this.mensaje=""
       this.mensaje_error=""
    }
  }
};
</script>

<style lang="scss" src="./Orders.scss"></style>
